// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-shift-rotation[data-v-18aa7113]{display:flex;align-items:center}.job-shift-rotation__label[data-v-18aa7113]{flex-grow:1}", ""]);
// Exports
module.exports = exports;
